import React, { useEffect } from 'react';
import dynamic from 'next/dynamic';
import { useDispatch, useSelector } from 'react-redux';
import {
  DynamicCodeSelector,
  getAccounts,
  getBlogs,
  getListings,
} from '../../store/feature/dynamicCode/dynamicCodeSlice';
const JSXParser = dynamic(() => import('react-jsx-parser'), { ssr: false });

const CustomDynamicCodeBlock = ({ data, styles }) => {
  const dispatch = useDispatch();
  const { listings, accounts, blogs } = useSelector(DynamicCodeSelector);

  useEffect(() => {
    dispatch(getListings({ page: 1, per_page: 30 }));
    dispatch(getAccounts({ page: 1, per_page: 30, type: 'accounts' }));
    dispatch(getBlogs({ page: 1, per_page: 30 }));
  }, []);

  return (
    <>
      <JSXParser
        bindings={{
          listings: listings,
          accounts: accounts,
          blogs: blogs,
        }}
        jsx={`${data.code} `}
        className="h-full w-full"
      />

      <section className=" hidden  flex-col items-center justify-center bg-gradient-to-r from-blue-500 to-purple-600 text-white p-10">
        <h1 className="text-4xl md:text-5xl font-bold mb-4">
          Empower Your Journey
        </h1>
        <p className="text-lg md:text-xl mb-6 text-center max-w-2xl">
          Discover the tools and resources you need to unlock your full
          potential and achieve your goals. Join us to start your transformative
          journey today!
        </p>
        <a
          href="#"
          className="bg-white text-blue-600 font-semibold py-2 px-6 rounded-lg shadow-lg transition duration-300 hover:bg-gray-200"
        >
          Get Started
        </a>
      </section>
    </>
  );
};

export default CustomDynamicCodeBlock;
